import styled from 'styled-components';
import React from 'react';

export const ErrorMsg = styled<
    React.FC<{ myRef: React.MutableRefObject<HTMLDivElement | null> }>
>(({ children, myRef, ...rest }) => {
    return (
        <div ref={myRef} {...rest}>
            {children}
        </div>
    );
})`
    position: absolute;
    background-color: crimson;
    color: white;
    font-size: 0.8rem;
    padding: 0.1rem 0.5rem;
    border-radius: ${({ theme }) => theme.defaults.borderRadius};
    line-height: 1.75rem;
    ${({ theme }) => theme.mixins.flexCenter};
`;
